import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import CarouselItem from './carousel-item';
import './carousel.scss';

export const NextArrow = props => {
    const { className, arrowClassName = '', style, onClick } = props;
    return (
        <div
            className={`arrow ${className} ${arrowClassName}`}
            style={{ ...style, display: 'block' }}
            onClick={() => {
                onClick();
            }}>
            {'->'}
        </div>
    );
};
export const PreviousArrow = props => {
    const { className, arrowClassName = '', style, onClick } = props;
    return (
        <div
            className={`arrow ${className} ${arrowClassName}`}
            style={{ ...style, display: 'block' }}
            onClick={() => {
                onClick();
            }}>
            {'<-'}
        </div>
    );
};

const Carousel = ({ containerType, data, inSPA, settings, videoEnabled }) => {
    const {
        hiddenOn,
        title,
        items,
        type = 'default',
        itemHeadersAsImageOverlay
    } = data;

    if (hiddenOn?.some(x => x === 'Web')) {
        return null;
    }

    const itemCount = items.length;
    const singleItemWithContent =
        itemCount === 1 &&
        (items[0].showHeading || items[0].button || items[0].body);
    const singleItemClass = singleItemWithContent ? 'carousel--single' : '';

    const isGrid = type === 'Grid';

    return (
        <section
            className={`carousel carousel-${type} carousel-count-${itemCount} ${singleItemClass} pt-5`}>
            {title && <h3 className="start-page-section-title">{title}</h3>}
            <Slider {...settings}>
                {items &&
                    items.map((item, index) => (
                        <div key={index} className="slider-item">
                            <CarouselItem
                                inSPA={inSPA}
                                item={item}
                                itemCount={itemCount}
                                itemHeadersAsImageOverlay={
                                    itemHeadersAsImageOverlay
                                }
                                containerType={containerType}
                                videoEnabled={videoEnabled}
                                isGrid={isGrid}
                            />
                        </div>
                    ))}
            </Slider>
        </section>
    );
};

Carousel.defaultProps = {
    settings: {
        dots: true,
        infinite: true,
        speed: 500,
        lazyLoad: 'progressive',
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        swipeToSlide: true,
        nextArrow: (
            <NextArrow arrowClassName="btn btn-outline-dark btn-round" />
        ),
        prevArrow: (
            <PreviousArrow arrowClassName="btn btn-outline-dark btn-round" />
        ),
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false
                }
            }
        ]
    }
};

Carousel.propTypes = {
    data: PropTypes.shape({
        title: PropTypes.string,
        items: PropTypes.array.isRequired,
        type: PropTypes.string
    }).isRequired,
    inSPA: PropTypes.bool,
    settings: PropTypes.object,
    videoEnabled: PropTypes.bool
};

export default Carousel;
